<section class="vh100">
    <div class="cw" fxLayout="column" fxLayoutAlign="center center">
        <div fxLayoutAlign="center">
            <mat-icon class="ftxxxl gray-4 linkIcon centertext"> mail</mat-icon>
        </div>

        <h6 class="h6Title centertext"> Soporte </h6>
        <p>
            Si has iniciado sesión podras utilizar el chat de soporte. Tambien puedes contactarnos directamente a traves de nuestro correo 
            <a href="mailto:contacto@predyc.com" target="_blank" class="blueLink">
                contacto@predyc.com
            </a>
        </p>
    </div>
</section>


<div>
    <div>
        Tienes alguna duda o quieres realizar alguna consulta acerca de nuestra plataforma
    </div>
</div>